import AppContext from 'App/AppContext';
import { useContext, useEffect, useState } from 'react';
import { graphGetInlineImageUrl } from 'services/Graph/graphServicePage';
import { ISitePage } from 'services/Graph/SharepointInterfaces';
import logger from 'services/Logging/logService';

interface ISharePointInlineImageProps {
  src: string;
  pageContent: ISitePage;
  siteId: string;
  listId?: string;
  alt?: string;
  width?: string;
  height?: string;
  alignment?: string;
}

export const SharePointInlineImage = (props: ISharePointInlineImageProps) => {
  const appContext = useContext(AppContext);
  const [imageSrc, setImageSrc] = useState<string | undefined>(undefined);

  useEffect(() => {
    const load = async () => {
      try {
        const url = await graphGetInlineImageUrl(appContext, props.siteId, props.pageContent.webUrl, props.src, props.listId);
        setImageSrc(url);
      } catch (err) {
        logger.debug('SharePointInlineImage', err);
      }
    };
    load();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.src, props.siteId, props.pageContent.webUrl, props.listId]);

  if (!imageSrc) return null;

  const align = props.alignment?.toLowerCase();
  const justifyContent = align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'flex-start';

  return (
    <div style={{ display: 'flex', justifyContent }}>
      <img
        src={imageSrc}
        alt={props.alt ?? ''}
        width={props.width}
        height={props.height}
        style={{ maxWidth: '100%' }}
      />
    </div>
  );
};
